/**
 * Type definitions for Contact.
 * These interfaces, aliases, or model helpers describe the shared data contract used
 * by the surrounding feature or UI layer.
 */
export interface ContactPhone {
  dialCode: number;
  iso2: string;
  country: string;
  number: string;
}

export interface ContactDetails {
  email: string;
  phone: ContactPhone;
}

export const DEFAULT_CONTACT_PHONE: ContactPhone = {
  dialCode: 0,
  iso2: '',
  country: '',
  number: ''
};
